module.exports = __webpack_public_path__ + "media/error.5a3edf95.wav";